import eventsBotWizardNames from '../events/botWizard';
import { useSendEvent } from '../useSendEvent';

const useGenerateBotOpened = () =>
	useSendEvent(eventsBotWizardNames.generateBotOpened, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useGenerateBotRebuild = () =>
	useSendEvent(eventsBotWizardNames.generateBotRebuild);

const useGenerateBotActivate = () =>
	useSendEvent(eventsBotWizardNames.generateBotActivate);

const useGenerateBotActivateUsingNeurons = () =>
	useSendEvent(eventsBotWizardNames.generateBotActivateUsingNeurons);

const useGenerateBotError = () =>
	useSendEvent(eventsBotWizardNames.generateBotError);

const useGenerateBotGenerationStep = () =>
	useSendEvent(eventsBotWizardNames.generateBotGenerationStep);

const useGenerateBotSummary = () =>
	useSendEvent(eventsBotWizardNames.generateBotSummary, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useGenerateBotDescription = () =>
	useSendEvent(eventsBotWizardNames.generateBotDescriptionStep, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const annalsBotWizard = {
	useGenerateBotOpened,
	useGenerateBotRebuild,
	useGenerateBotActivate,
	useGenerateBotActivateUsingNeurons,
	useGenerateBotError,
	useGenerateBotSummary,
	useGenerateBotDescription,
	useGenerateBotGenerationStep,
};

export default annalsBotWizard;
